<div [class.info-header]="!isModal">
  <div [class.container-fluid]="!isModal" [class.lh-container-fluid-sm]="!isModal">
    <div class="flex">
      <!-- Heading and section number -->
      <div *ngIf="!isModal && isInitialized">
        <h1 class="heading-5" (click)="printDebugInfo()">
          <span *ngIf="!shop || !shop.name">{{ (isExistingShop ? 'EDIT_SHOP' : 'ADD_SHOP') | translate }}</span>
          <span *ngIf="shop && shop.name">{{ shop.name }}</span>
        </h1>
        <span *ngIf="!isExistingShop && currentSection > 0">
          {{ 'STEP_NUMBER' | translate }} {{ currentSection }} {{ 'OF_TOTAL_STEPS' | translate }} {{ numberOfSections }}
        </span>
      </div>

      <!-- Tabbed navigation -->
      <div *ngIf="isExistingShop" class="tab-group" [class.in-modal]="isModal">
        <!-- TODO: Create via ngFor instead -->
        <button
          id="showSection3"
          (click)="goToSection(1)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 1"
        >
          {{ 'ADDRESS' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(3)">!</span>
        </button>
        <button
          id="showSection1"
          (click)="goToSection(2)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 2"
        >
          {{ 'BASIC_PROFILE' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(1)">!</span>
        </button>
        <button
          id="showSection2"
          (click)="goToSection(3)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 3"
        >
          {{ 'SHOP_NOTIFICATIONS' | translate
          }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(2)">!</span>
        </button>
        <button
          id="showSection4"
          (click)="goToSection(4)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 4"
        >
          {{ 'CONTACT' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(4)">!</span>
        </button>
        <button
          id="showSection5"
          (click)="goToSection(5)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 5"
        >
          {{ 'WIFI' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(5)">!</span>
        </button>
        <button
          id="showSection6"
          (click)="goToSection(6)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 6"
        >
          {{ 'OPENING_HOURS' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(6)">!</span>
        </button>
        <button
          id="showSection7"
          (click)="goToSection(7)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 7"
        >
          {{ 'HOLIDAYS' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(7)">!</span>
        </button>
        <button
          id="showSection8"
          (click)="goToSection(8)"
          class="btn btn-info btn-tab"
          [class.active]="currentSection === 8"
        >
          {{ 'IMAGES' | translate }}<span class="section-badge-warning" *ngIf="!isSectionCompleted(8)">!</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Main container with progress and shop form -->
<div class="navigation-padding" [class.container-fluid]="!isModal" [class.lh-container-fluid-sm]="!isModal">
  <!-- Progress bar -->
  <div class="progress-container" *ngIf="!isExistingShop">
    <div class="progress-fill" [style.width.%]="progress">
      <div class="progress-label">{{ progress }}%</div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <!-- Form containing all shop input elements -->
      <form #form="ngForm" [hidden]="isLoading && currentSection > 0" *ngIf="shop">
        <!-- Section 1 - Location -->
        <div [hidden]="currentSection !== 1">
          <label>{{ 'ADDRESS' | translate }}</label>

          <div *ngIf="isEditPrivilegedFieldsAllowed">
            <p>{{ 'SHOP_ADDRESS_TEXT_PART_1' | translate }}</p>

            <div class="form-group">
              <!-- Google places search -->
              <lh-places-search
                #placesSearch
                [placeholder]="'SHOP_SEARCH_GOOGLE' | translate"
                (valueChange)="onPlaceChanged($event)"
                [location]="selectedLocation"
                [businessesOnly]="true"
                [disabled]="isNotOnGoogle"
                [formControlMode]="true"
                [class.places-disabled]="isNotOnGoogle"
                [class.missing]="!isPlaceSelected && isOnGoogle"
                [class.complete]="isPlaceSelected && isOnGoogle"
              >
              </lh-places-search>

              <!-- No Google checkbox -->
              <label class="checkbox-label" *ngIf="!isPlaceSelected">
                <input id="isNotOnGoogle" name="isNotOnGoogle" type="checkbox" [(ngModel)]="isNotOnGoogle" />
                &nbsp;{{ 'SHOP_NOT_ON_GOOGLE' | translate }}
              </label>
            </div>

            <div class="form-group">
              <!-- Connected Google Place panel -->
              <ul class="list-group google-place-container" *ngIf="isOnGoogle">
                <div class="list-group-item google-place-item">
                  <div class="media">
                    <div class="media-left">
                      <img
                        class="google-maps-icon"
                        [class.complete]="isPlaceSelected"
                        height="44"
                        width="44"
                        src="../../../../assets/GoogleMaps_logo.svg"
                      />
                    </div>

                    <div class="media-body">
                      <h4 class="media-heading">
                        {{ isPlaceSelected ? shop.place.name : ('NOT_CONNECTED' | translate) }}
                      </h4>
                      <div>
                        <div *ngIf="isPlaceSelected">{{ shop.address.formattedAddress }}</div>
                        <div *ngIf="!isPlaceSelected">{{ 'SELECT_GOOGLE_PLACE' | translate }}</div>
                        <div class="d-none d-sm-block" *ngIf="isPlaceSelected">
                          <small>{{ 'PLACE_ID' | translate }} {{ shop.place.id }}</small>
                        </div>
                      </div>
                    </div>

                    <div class="text-end mt-1" *ngIf="isPlaceSelected">
                      <button
                        id="clearSelectedPlace"
                        class="btn btn-sm btn-info me-1"
                        (click)="clearSelectedPlace($event)"
                      >
                        {{ 'DISCONNECT' | translate }}
                      </button>
                      <a id="viewInGoogleMaps" class="btn btn-sm btn-info" target="_blank" [href]="shop | mapsLink">
                        {{ 'VIEW_IN_MAPS' | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </ul>
            </div>

            <!-- Map -->
            <div class="form-group map-wrapper">
              <lh-storage-location-map
                [center]="mapCenter"
                [zoom]="mapInitialZoom"
                [usePanning]="true"
                [clickableIcons]="false"
                [keyboardShortcuts]="false"
                [scaleControl]="false"
                [streetViewControl]="false"
                [zoomControl]="true"
                [scrollwheel]="false"
                [draggable]="true"
                [styles]="mapStyles"
                [storageLocationObfuscation]="false"
                [largeStorageLocationMarkers]="true"
                [storageLocations]="mapShops"
              >
              </lh-storage-location-map>
            </div>
          </div>

          <!-- Address -->
          <div class="form-group">
            <!-- Street -->
            <input
              id="street"
              name="street"
              #street="ngModel"
              type="text"
              (change)="geocodeAddress()"
              class="form-control"
              [class.missing]="isMissing(street)"
              [class.complete]="isComplete(street)"
              [(ngModel)]="shop.address.street"
              [placeholder]="'STREET' | translate"
              required
              [disabled]="!isEditPrivilegedFieldsAllowed"
            />
            <div *ngIf="street.touched && !street.valid" class="alert alert-danger">
              {{ 'STREET_REQUIRED' | translate }}
            </div>

            <!-- City -->
            <input
              id="city"
              name="city"
              #city="ngModel"
              type="text"
              (change)="geocodeAddress()"
              class="form-control"
              [class.missing]="isMissing(city)"
              [class.complete]="isComplete(city)"
              [(ngModel)]="shop.address.city"
              [placeholder]="'CITY' | translate"
              required
              [disabled]="!isEditPrivilegedFieldsAllowed"
            />
            <div *ngIf="city.touched && !city.valid" class="alert alert-danger">
              {{ 'CITY_REQUIRED' | translate }}
            </div>

            <!-- Postal code -->
            <input
              id="postal"
              name="postal"
              #postal="ngModel"
              type="text"
              (change)="geocodeAddress()"
              class="form-control"
              [class.missing]="isMissing(postal)"
              [class.complete]="isComplete(postal)"
              [(ngModel)]="shop.address.postal"
              [placeholder]="'POSTAL_CODE' | translate"
              required
              [disabled]="!isEditPrivilegedFieldsAllowed"
            />
            <div *ngIf="postal.touched && !postal.valid" class="alert alert-danger">
              {{ 'POSTAL_CODE_REQUIRED' | translate }}
            </div>

            <!-- Country -->
            <input
              id="country"
              name="country"
              #country="ngModel"
              [typeahead]="countries"
              type="text"
              (change)="geocodeAddress()"
              class="form-control"
              [class.missing]="isMissing(country)"
              [class.complete]="isComplete(country)"
              [(ngModel)]="shop.address.country"
              [placeholder]="'COUNTRY' | translate"
              required
              [disabled]="!isEditPrivilegedFieldsAllowed"
            />
            <div *ngIf="country.touched && !country.valid" class="alert alert-danger">
              {{ 'COUNTRY_REQUIRED' | translate }}
            </div>
            <div *ngIf="!isEditPrivilegedFieldsAllowed" class="small text-end">
              <lh-shared-ui-tooltip
                [callToAction]="'NEED_TO_CHANGE' | translate"
                [body]="'CONTACT_SUPPORT_TO_CHANGE' | translate"
              ></lh-shared-ui-tooltip>
            </div>
          </div>

          <!-- Directions text -->
          <div class="form-group mt-4">
            <p>{{ 'SHOP_DIRECTIONS_EXPLANATION' | translate }}</p>
            <textarea
              id="directions"
              name="directions"
              type="text"
              rows="3"
              maxlength="500"
              class="text-area form-control"
              [(ngModel)]="shop.directionsText"
              [placeholder]="'SHOP_DIRECTIONS_EXAMPLE' | translate"
              [disabled]="!isEditPrivilegedFieldsAllowed"
            >
            </textarea>
            <div *ngIf="!isEditPrivilegedFieldsAllowed" class="small text-end">
              <lh-shared-ui-tooltip
                [callToAction]="'NEED_TO_CHANGE' | translate"
                [body]="'CONTACT_SUPPORT_TO_CHANGE' | translate"
              ></lh-shared-ui-tooltip>
            </div>
          </div>
        </div>

        <!-- Section 2 - Basic Info -->
        <div [hidden]="currentSection !== 2">
          <label>{{ 'BUSINESS_INFORMATION' | translate }}</label>
          <p>{{ 'BUSINESS_INFORMATION_EXPLANATION' | translate }}</p>

          <!-- Shop name -->
          <div class="form-group">
            <input
              id="name"
              name="name"
              #name="ngModel"
              type="text"
              class="form-control"
              [class.missing]="isMissing(name)"
              [class.complete]="isComplete(name)"
              [(ngModel)]="shop.name"
              [placeholder]="'SHOP_NAME' | translate"
              maxlength="50"
              required
              [disabled]="!isEditPrivilegedFieldsAllowed"
            />
            <div *ngIf="!isEditPrivilegedFieldsAllowed" class="small text-end href">
              <lh-shared-ui-tooltip
                [callToAction]="'NEED_TO_CHANGE' | translate"
                [body]="'CONTACT_SUPPORT_TO_CHANGE' | translate"
              ></lh-shared-ui-tooltip>
            </div>
            <div *ngIf="name.touched && !name.valid" class="alert alert-danger">
              {{ 'NAME_IS_REQUIRED' | translate }}
            </div>

            <!-- VAT number -->
            <input
              id="vatNumber"
              name="vatNumber"
              #vatNumber="ngModel"
              type="text"
              class="form-control"
              [class.missing]="isMissing(vatNumber)"
              [class.complete]="isComplete(vatNumber)"
              [(ngModel)]="shop.vatNumber"
              [placeholder]="'VAT_NUMBER_PLACEHOLDER' | translate"
              [disabled]="hasNoVatNumber"
              lhVatNumber
              required
            />
            <div *ngIf="vatNumber.enabled && vatNumber.touched && !vatNumber.valid" class="alert alert-danger">
              <span *ngIf="vatNumber.errors.required">{{ 'VAT_NUMBER_REQUIRED' | translate }}</span>
              <span *ngIf="vatNumber.errors.countryCodeRequired">{{
                'VAT_NUMBER_COUNTRY_CODE_MISSING' | translate
              }}</span>
              <span *ngIf="vatNumber.errors.invalidVatNumber">{{ 'VAT_NUMBER_INVALID' | translate }}</span>
            </div>

            <!-- No VAT number checkbox -->
            <div class="text-end">
              <label class="checkbox-label">
                <input id="hasNoVatNumber" name="hasNoVatNumber" type="checkbox" [(ngModel)]="hasNoVatNumber" />
                &nbsp;{{ 'NO_VAT_NUMBER' | translate }}
              </label>
            </div>
          </div>

          <label>{{ 'STORAGE_AREA' | translate }}</label>
          <p>{{ 'BASIC_SHOP_PROFILE_PART_3' | translate }}</p>

          <!-- Capacity -->
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-text">{{ 'CAPACITY' | translate }} ({{ 'BAGS' | translate | lowercase }})</span>
              <input
                id="normal"
                name="normal"
                #normal="ngModel"
                type="number"
                class="form-control"
                [class.missing]="isMissing(normal)"
                [class.complete]="isComplete(normal)"
                [(ngModel)]="shop.capacity.normal"
                [min]="shop.minimumCapacity.normal"
                [max]="shop.maximumCapacity.normal"
                required
              />
            </div>
            <div *ngIf="normal.touched && normal.errors" class="alert alert-danger">
              {{ 'CAPACITY_REQUIRED' | translate }}
              <span *ngIf="normal.errors.min || normal.errors.max"
                >({{ shop.minimumCapacity.normal }}-{{ shop.maximumCapacity.normal }})</span
              >
            </div>
          </div>

          <div *ngIf="isGuestStorageEnabled">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-text">{{ 'MAX_CAPACITY_FOR_ADVANCE_BOOKINGS' | translate }}</span>
                <input
                  id="maxCapacityForAdvanceBookings"
                  name="maxCapacityForAdvanceBookings"
                  #normal="ngModel"
                  type="number"
                  class="form-control"
                  [class.missing]="isMissing(maxCapacityForAdvanceBookings)"
                  [class.complete]="isComplete(maxCapacityForAdvanceBookings)"
                  [(ngModel)]="shop.maxCapacityForAdvanceBookings"
                  [min]="0"
                  [max]="100"
                  [step]="5"
                  required
                />
              </div>
              <div *ngIf="normal.touched && normal.errors" class="alert alert-danger">
                {{ 'MAX_CAPACITY_FOR_ADVANCE_BOOKINGS_REQUIRED' | translate }}
              </div>
            </div>

            <p *ngIf="!shop.storageRoomAccessBackupCode">{{ 'STORAGE_AREA_ACCESS_EXPLANATION' | translate }}</p>

            <!-- Storage room access code -->
            <div class="form-group" *ngIf="!shop.storageRoomAccessBackupCode">
              <div class="input-group">
                <span class="input-group-text">{{ 'ACCESS_CODE' | translate }}</span>
                <input
                  id="storageRoomAccessCode"
                  name="storageRoomAccessCode"
                  #storageRoomAccessCode="ngModel"
                  type="text"
                  class="form-control"
                  [(ngModel)]="shop.storageRoomAccessCode"
                  [placeholder]="'STORAGE_ROOM_ACCESS_CODE_PLACEHOLDER' | translate"
                  maxlength="10"
                />
              </div>
            </div>

            <p *ngIf="shop.storageRoomAccessBackupCode">{{ 'STORAGE_AREA_BACKUP_ACCESS_EXPLANATION' | translate }}</p>

            <!-- Storage room access backup code -->
            <div class="form-group" *ngIf="shop.storageRoomAccessBackupCode">
              <div class="input-group">
                <span class="input-group-text">{{ 'BACKUP_ACCESS_CODE' | translate }}</span>
                <input
                  id="storageRoomAccessBackupCode"
                  name="storageRoomAccessBackupCode"
                  #storageRoomAccessBackupCode="ngModel"
                  type="text"
                  class="form-control"
                  [(ngModel)]="shop.storageRoomAccessBackupCode"
                  maxlength="10"
                  readonly
                  [disabled]="true"
                />
              </div>
            </div>

            <!-- Storage room access text -->
            <div class="form-group">
              <textarea
                id="storageRoomAccessText"
                name="storageRoomAccessText"
                #storageRoomAccessText="ngModel"
                class="form-control"
                [ngStyle]="{ resize: 'none' }"
                [(ngModel)]="shop.storageRoomAccessText"
                [placeholder]="'STORAGE_ROOM_ACCESS_TEXT_PLACEHOLDER' | translate"
                rows="3"
                maxlength="150"
              ></textarea>
            </div>
          </div>
        </div>

        <!-- Section 3 - Notifications -->
        <div [hidden]="currentSection !== 3">
          <!--Notifications section-->
          <label>{{ 'SHOP_NOTIFICATIONS' | translate }}</label>
          <p>{{ 'SHOP_NOTIFICATIONS_EXPLANATION_PART_1' | translate }}</p>

          <div class="form-group">
            <!-- Notifications contact -->
            <input
              id="primaryContact"
              name="primaryContact"
              #primaryContact="ngModel"
              type="text"
              class="form-control"
              [class.missing]="isMissing(primaryContact)"
              [class.complete]="isComplete(primaryContact)"
              [(ngModel)]="shop.primaryContact"
              [placeholder]="'NOTIFICATIONS_CONTACT' | translate"
              maxlength="100"
              required
            />
            <button
              *ngIf="shouldSuggest(user.name, 'primaryContact')"
              class="btn btn-default btn-autofill"
              (click)="applySuggestion(user.name, 'primaryContact')"
            >
              {{ user.name }}
            </button>
            <div *ngIf="primaryContact.touched && !primaryContact.valid" class="alert alert-danger">
              {{ 'NOTIFICATIONS_CONTACT_IS_REQUIRED' | translate }}
            </div>

            <!-- Notifications email -->
            <input
              id="email"
              name="email"
              #email="ngModel"
              type="email"
              autocomplete="email"
              class="form-control"
              [(ngModel)]="shop.email"
              [placeholder]="'EMAIL_ADDRESS' | translate"
            />
            <button
              *ngIf="shouldSuggest(user.email, 'email')"
              class="btn btn-default btn-autofill"
              (click)="applySuggestion(user.email, 'email', true)"
            >
              {{ user.email }}
            </button>
            <div *ngIf="email.touched && !email.valid" class="alert alert-danger">
              {{ 'NOTIFICATIONS_EMAIL_IS_REQUIRED' | translate }}
            </div>

            <!-- Notifications SMS -->
            <input
              id="sms"
              name="sms"
              #sms="ngModel"
              type="tel"
              class="form-control"
              [(ngModel)]="shop.sms"
              [placeholder]="'SMS_PHONE_NUMBER' | translate"
              lhPhoneNumber="multiple"
            />
            <button
              *ngIf="shouldSuggest(user.phone, 'sms')"
              class="btn btn-default btn-autofill"
              (click)="applySuggestion(user.phone, 'sms', true)"
            >
              {{ user.phone }}
            </button>
            <div *ngIf="!sms.valid" class="alert alert-danger">
              {{ 'INVALID_PHONE_NUMBER_COUNTRY' | translate }}
            </div>
          </div>

          <p>{{ 'SHOP_NOTIFICATIONS_EXPLANATION_PART_2' | translate }}</p>

          <div class="form-group">
            <label>{{ 'SHOP_NOTIFICATIONS_OPT_IN_OUT_HEADER' | translate }}</label>
            <p>{{ 'SHOP_NOTIFICATIONS_OPT_IN_OUT_EXPLANATION' | translate }}</p>

            <div class="notification-radio-buttons">
              <div class="row">
                <div class="col-6">{{ 'NOTIFICATION_CONFIRMED_BOOKING' | translate }}</div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="confirmationNotificationEnabled"
                      name="confirmationNotification"
                      type="radio"
                      [(ngModel)]="confirmationNotification"
                      [value]="true"
                      required
                    />
                    &nbsp;Yes
                  </label>
                </div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="confirmationNotificationDisabled"
                      name="confirmationNotification"
                      type="radio"
                      [(ngModel)]="confirmationNotification"
                      [value]="false"
                      required
                    />
                    &nbsp;No
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-6">{{ 'NOTIFICATION_CHECKEDIN_BOOKING' | translate }}</div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="checkInNotificationEnabled"
                      name="checkInNotification"
                      type="radio"
                      [(ngModel)]="checkInNotification"
                      [value]="true"
                      required
                    />
                    &nbsp;Yes
                  </label>
                </div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="checkInNotificationDisabled"
                      name="checkInNotification"
                      type="radio"
                      [(ngModel)]="checkInNotification"
                      [value]="false"
                      required
                    />
                    &nbsp;No
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-6">{{ 'NOTIFICATION_CHECKEDOUT_BOOKING' | translate }}</div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="checkOutNotificationEnabled"
                      name="checkOutNotification"
                      type="radio"
                      [(ngModel)]="checkOutNotification"
                      [value]="true"
                      required
                    />
                    &nbsp;Yes
                  </label>
                </div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="checkOutNotificationDisabled"
                      name="checkOutNotification"
                      type="radio"
                      [(ngModel)]="checkOutNotification"
                      [value]="false"
                      required
                    />
                    &nbsp;No
                  </label>
                </div>
              </div>

              <!-- <div class="row">
                <div class="col-6">{{ 'NOTIFICATION_ONLINE_PAYMENT_SUCCESSFUL' | translate }}</div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="paymentSuccessfulNotificationEnabled"
                      name="paymentSuccessfulNotification"
                      type="radio"
                      [(ngModel)]="paymentSuccessfulNotification"
                      [value]="true"
                      required
                    />
                    &nbsp;Yes
                  </label>
                </div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="paymentSuccessfulNotificationDisabled"
                      name="paymentSuccessfulNotification"
                      type="radio"
                      [(ngModel)]="paymentSuccessfulNotification"
                      [value]="false"
                      required
                    />
                    &nbsp;No
                  </label>
                </div>
              </div> -->

              <div class="row">
                <div class="col-6">{{ 'NOTIFICATION_ONLINE_PAYMENT_FAILED' | translate }}</div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="paymentFailedNotificationEnabled"
                      name="paymentFailedNotification"
                      type="radio"
                      [(ngModel)]="paymentFailedNotification"
                      [value]="true"
                      required
                    />
                    &nbsp;Yes
                  </label>
                </div>
                <div class="col-3">
                  <label class="checkbox-label">
                    <input
                      id="paymentFailedNotificationDisabled"
                      name="paymentFailedNotification"
                      type="radio"
                      [(ngModel)]="paymentFailedNotification"
                      [value]="false"
                      required
                    />
                    &nbsp;No
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!--Billing section-->
          <label>{{ 'SHOP_BILLING_CONTACT' | translate }}</label>
          <p>{{ 'SHOP_BILLING_TEXT' | translate }}</p>

          <!-- Billing email -->
          <div class="form-group">
            <input
              id="billingEmail"
              name="billingEmail"
              type="email"
              autocomplete="email"
              class="form-control"
              [(ngModel)]="shop.billingEmail"
              [placeholder]="'EMAIL_ADDRESS' | translate"
            />
            <button
              *ngIf="shouldSuggest(user.email, 'billingEmail')"
              class="btn btn-default btn-autofill"
              (click)="applySuggestion(user.email, 'billingEmail', true)"
            >
              {{ user.email }}
            </button>
          </div>
        </div>

        <!-- Section 4 - Contact Info -->
        <div [hidden]="currentSection !== 4">
          <!-- Contact information section -->
          <label>{{ 'SHOP_CONTACT_INFO' | translate }}</label>
          <p>{{ 'VISIBLE_TO_TRAVELERS' | translate }}</p>

          <div class="form-group">
            <!-- Shop contact phone number -->
            <input
              id="phone"
              name="phone"
              type="tel"
              class="form-control"
              [(ngModel)]="shop.phone"
              [placeholder]="'PHONE_NUMBER' | translate"
            />
            <div *ngIf="shop.sms">
              <span *ngFor="let existingPhone of shop.sms.split(',')">
                <button
                  *ngIf="shouldSuggest(existingPhone, 'phone')"
                  class="btn btn-default btn-autofill"
                  (click)="applySuggestion(existingPhone, 'phone')"
                >
                  {{ existingPhone }}
                </button>
              </span>
            </div>

            <!-- Shop contact email -->
            <input
              id="contactEmail"
              name="contactEmail"
              type="email"
              autocomplete="email"
              class="form-control"
              [(ngModel)]="shop.contactEmail"
              [placeholder]="'EMAIL_ADDRESS' | translate"
            />
            <div *ngIf="shop.email">
              <span *ngFor="let existingEmail of shop.email.split(',')">
                <button
                  *ngIf="shouldSuggest(existingEmail, 'contactEmail')"
                  class="btn btn-default btn-autofill"
                  (click)="applySuggestion(existingEmail, 'contactEmail')"
                >
                  {{ existingEmail }}
                </button>
              </span>
            </div>

            <!-- Shop website -->
            <input
              id="website"
              name="website"
              type="url"
              class="form-control"
              [(ngModel)]="shop.website"
              [placeholder]="'WEBSITE' | translate"
            />
          </div>
        </div>

        <!-- Section 5: Wi-Fi -->
        <div [hidden]="currentSection !== 5">
          <label>{{ 'WIFI' | translate }}</label>
          <p>{{ 'SHOP_PROFILE_WIFI_EXPLANATION_PART_1' | translate }}</p>
          <p>{{ 'SHOP_PROFILE_WIFI_EXPLANATION_PART_2' | translate }}</p>

          <!-- Wi-Fi radio buttons -->
          <div class="form-group radio-buttons">
            <label class="checkbox-label">
              <input id="hasWifi" name="hasWifi" type="radio" [(ngModel)]="hasWifi" [value]="true" required />
              &nbsp;{{ 'HAS_WIFI' | translate }}
            </label>
            <label class="checkbox-label">
              <input id="noWifi" name="noWifi" type="radio" [(ngModel)]="hasWifi" [value]="false" required />
              &nbsp;{{ 'NO_WIFI' | translate }}
            </label>
            <i [class.icon-missing]="!isWifiCompleted" [class.icon-completed]="isWifiCompleted"></i>
          </div>

          <!-- Wi-Fi network details -->
          <div class="form-group" *ngIf="wifiInfo">
            <input
              id="wifiSsid"
              name="wifiSsid"
              type="text"
              class="form-control"
              [disabled]="!hasWifi"
              [(ngModel)]="wifiInfo.ssid"
              [placeholder]="'WIFI_SSID' | translate"
            />
            <input
              id="wifiPass"
              name="wifiPass"
              type="text"
              class="form-control"
              [disabled]="!hasWifi"
              [(ngModel)]="wifiInfo.password"
              [placeholder]="'WIFI_PASSWORD' | translate"
            />
            <input
              id="wifiUser"
              name="wifiUser"
              type="text"
              class="form-control"
              [disabled]="!hasWifi"
              [(ngModel)]="wifiInfo.username"
              [placeholder]="'WIFI_USERNAME' | translate"
            />
          </div>
        </div>

        <!-- Section 6: Regular opening hours and exceptions -->
        <div [hidden]="currentSection !== 6">
          <div class="form-group">
            <label>{{ 'REGULAR_OPENING_HOURS' | translate }}</label>
            <lh-manage-opening-hours
              [(openingHours)]="shop.openingHours"
              [country]="shop.address.countryCode"
              #openingHoursForm
            >
            </lh-manage-opening-hours>
          </div>

          <hr />

          <div class="form-group" *ngIf="isExistingShop">
            <label>{{ 'EXCEPTIONAL_OPENING_HOURS' | translate }}</label>
            <lh-manage-exceptional-opening-hours
              [(openingHours)]="shop.openingHours"
              [country]="shop.address.countryCode"
              #exceptionalOpeningHoursForm
            >
            </lh-manage-exceptional-opening-hours>
          </div>
        </div>

        <!-- Section 7: Holiday opening hours -->
        <div [hidden]="currentSection !== 7">
          <label (click)="onHolidayHeaderClick()">{{ 'HOLIDAY_OPENING_HOURS' | translate }}</label>

          <div *ngIf="!shop.address || !shop.address.countryCode">
            {{ 'NO_HOLIDAYS_BEFORE_ADDRESS' | translate }}
          </div>

          <!-- Holiday opening hours picker -->
          <lh-manage-holiday-opening-hours
            *ngIf="shop.address && shop.address.countryCode"
            [(openingHours)]="shop.openingHours"
            [validateHolidays]="requireHolidays"
            [country]="shop.address.countryCode"
            #holidayOpeningHoursForm
          >
          </lh-manage-holiday-opening-hours>
        </div>

        <!-- Section 8: Images -->
        <div [hidden]="currentSection !== 8" *ngIf="shop && shop._id">
          <label>{{ 'IMAGES' | translate }}</label>
          <p>{{ 'SHOP_IMAGES_EXPLANATION' | translate }}</p>

          <div class="form-group">
            <lh-images #lhImages [shop]="shop" (imagesChange)="onImagesChanged($event)"></lh-images>
          </div>

          <div class="small" *ngIf="imagesAdded">{{ 'IMAGES_CAN_TAKE_TIME' | translate }}</div>
        </div>
      </form>

      <!-- 
        Section 9: Payout Method

        NOTE: This section is located outside of the form tag as otherwise we get errors from 
        angular due to ngModel binding on elements without names 
      -->
      <!-- <div [hidden]="currentSection !== 9" *ngIf="isPayoutAccountFlowInitialized">
        <label>{{ 'AUTOMATED_PAYOUTS' | translate }}</label>

        <div *ngIf="payoutMethods.length > 0">
          <p>
            {{ 'YOURE_ALL_SET' | translate }} {{ 'REVENUE_TRANSFERRED_TO_YOUR_ACCOUNT_WITH_BANK_NAME' | translate }}
            {{ payoutMethods[0].data.bank_name }} ({{ 'ACCOUNT_NUMBER_ENDING_IN' | translate | lowercase }}
            {{ payoutMethods[0].data.last4 }}).
          </p>
          <div class="alert alert-success">
            <div class="alert-message">{{ 'ALL_SHOP_INFORMATION_PROVIDED' | translate }}</div>
          </div>
        </div>

        <div *ngIf="payoutMethods.length === 0">
          <lh-manage-payout-methods [selectedCountry]="shop.address.countryCode></lh-manage-payout-methods>
          <hr />
          <p>{{ 'FINISH_AND_ADD_PAYOUT_METHOD_LATER' | translate }}</p>
        </div>
      </div> -->
    </div>

    <div class="text-center">
      <lh-shared-ui-spinner [visible]="isLoading || currentSection === 0"></lh-shared-ui-spinner>
    </div>
  </div>
</div>

<!-- Back and next navigation buttons docked to bottom of screen -->
<div class="navigation-buttons" *ngIf="!isExistingShop">
  <button id="goForward" type="button" class="btn" (click)="goBack()" [disabled]="!canGoBack || isLoading">
    <i class="icon-prev"></i>{{ 'STEP_BACK' | translate }}
  </button>
  <span class="divider"></span>
  <button id="goBack" type="button" class="btn" (click)="goForward()" [disabled]="!canGoForward || isLoading">
    {{ (isLastSection ? 'FINISH' : 'STEP_FORWARD') | translate }}<i class="icon-next"></i>
  </button>
</div>

<!-- Cancel and save buttons docked to bottom of screen -->
<div class="navigation-buttons" *ngIf="isExistingShop">
  <button id="cancelChanges" type="button" class="btn" (click)="onCancel()">
    {{ 'CANCEL' | translate }}
  </button>
  <span class="divider"></span>
  <button id="saveChanges" type="button" class="btn" (click)="saveShop(true)" [disabled]="isPristine || isLoading">
    {{ 'SAVE' | translate }}
  </button>
</div>
